import { Typography } from '@execonline-inc/execonline-ui';
import { when } from '@execonline-inc/maybe-adapter';
import { observer } from 'mobx-react';
import EmptyKeyMetrics from '../../../EmptyComponents/EmptyKeyMetrics';

interface Props {
  numerator: number;
  denominator: number;
}

function Card({ numerator, denominator }: Props) {
  return when(numerator > 0 && denominator > 0, {})
    .map(() => (
      <div className="flex mr-[4%]">
        <Typography fontWeight="bold" variant="h4" color="dark">
          {numerator}
        </Typography>
        <Typography variant="h4" color="dark">
          /{denominator}
        </Typography>
      </div>
    ))
    .getOrElse(() => <EmptyKeyMetrics />);
}

export default observer(Card);
